import React from 'react';
import { Grid, Cell } from 'react-foundation';
import { useNavigate } from 'react-router-dom';
import { Header, ProgressBar, FlashMessage, ErrorRender } from '../../constants/SharedComponents';
import { useDemoContext } from '../../contexts/DemoContext';

export function DemoTeamMemberPrepNew() {
  const navigate = useNavigate();
  const { nextDemoStep } = useDemoContext();

  const [loading, setLoading] = React.useState(false);
  const [flashMessageObject, setFlashMessageObject] = React.useState({});
  const [error] = React.useState(null);
  const [inputs, setInputs] = React.useState({});
  const basicFormButtons = React.useRef([]);

  // Demo data to mimic the original's data structure
  const demoData = {
    isUserManager: false  // This ensures the form is shown (team member view)
  };

  // Demo question data mimicking the original API structure
  const demoQuestionData = [
    {
      id: 'demo-question-1',
      questionText: 'In general, how do you find your job?',
      questionOptions: JSON.stringify([
        { OptionText: 'Not At All Stressful', OptionScore: 1 },
        { OptionText: 'Mildly Stressful', OptionScore: 2 },
        { OptionText: 'Moderately Stressful', OptionScore: 3 },
        { OptionText: 'Very Stressful', OptionScore: 4 },
        { OptionText: 'Extremely Stressful', OptionScore: 5 }
      ])
    }
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    
    // For demo purposes, allow users to skip the question
    setFlashMessageObject({});
    setLoading(true);
    // Store the selection for demo purposes
    nextDemoStep();
    // Navigate to route choice page where user can choose guided or self-reflection
    navigate('/demo/conversations/demo-conversation-123/team-member-prep/routes');
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  return (
    <>
      <ProgressBar loading={loading} />
      <Header />
      <FlashMessage object={flashMessageObject} columnWrap={true} />
      <ErrorRender object={error} />

      {demoData && demoQuestionData && (
        <div className="grid-container">
          <Grid className="grid-padding-x align-justify">
            <Cell small={12}>
              <div className="page-content">
                <h1 className="page-content__title">How are things going in your work?</h1>

                <div className="page-content__styles">
                  <p>
                    Please consider the following question and answer as you feeling at this
                    moment.
                  </p>
                </div>
              </div>

              {!demoData.isUserManager && (
                <form>
                  <div className="basic-form basic-form--background">
                    {demoQuestionData.map((question, questionIndex) => {
                      return (
                        <div
                          className="basic-form__field basic-form__field"
                          key={'question-' + question.id}
                        >
                          <p className="basic-form__title">{question.questionText}</p>

                          <Grid>
                            {JSON.parse(question.questionOptions).map(
                              (questionOption, optionIndex) => {
                                return (
                                  <Cell large={2}
                                    key={
                                      'question-' +
                                      question.id +
                                      '-response-' +
                                      questionOption.OptionScore
                                    }
                                  >
                                    <div
                                      className="basic-form__field basic-form__field--inline"
                                      key={
                                        'question-' +
                                        question.id +
                                        '-response-' +
                                        questionOption.OptionScore
                                      }
                                      style={{ display: 'flex', paddingBottom: '15px' }}
                                    >
                                      <input
                                        type="radio"
                                        name={'question_score[' + question.id + '][option_score]'}
                                        value={questionOption.OptionScore}
                                        onChange={handleChange}
                                        className="basic-form__radio-button"
                                        id={
                                          'util--question-' +
                                          questionIndex +
                                          '-response-' +
                                          optionIndex
                                        }
                                      />

                                      <label
                                        htmlFor={
                                          'util--question-' +
                                          questionIndex +
                                          '-response-' +
                                          optionIndex
                                        }
                                      >
                                        {questionOption.OptionText}
                                      </label>
                                    </div>
                                  </Cell>
                                );
                              },
                            )}
                          </Grid>
                        </div>
                      );
                    })}
                  </div>

                  <input
                    value="Next Step"
                    type="submit"
                    className="mt-2 basic-form__button basic-form-route-choice__button"
                    onClick={handleSubmit}
                    ref={(ref) => (basicFormButtons.current[0] = ref)}
                    id="page-form-button--submit-guided"
                  />
                </form>
              )}
            </Cell>
          </Grid>
        </div>
      )}
    </>
  );
}
